import { Toast } from "@tandemdiabetes/sugarmate-react-components"
import { usePolyglot } from "src/contexts"

interface Props {
  id: string;
}

export function RemoveSourceErrorToast(props: Props) {
  const { id } = props

  const polyglot = usePolyglot()

  return (
    <Toast
      stylePreset="error"
      body={polyglot.t(
        "toasts.remove_source_error.body",
      )}
      id={id}
    />
  )
}
